module.exports = __webpack_public_path__ + "img/EducationalGroupAttendances.6d27f4b1.svg";